import React, { useState } from "react";
import { Container, Row, Col, Card, InputGroup, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import YesNoModal from './YesNo_Quest';
import TrueFalseModel from './TrurFalse_Quest'
import RightWrongModel from './RightWrong_Quest'

const CreateExam = () => {

  const [examData, setExamData] = useState({
    std: "",
    div: "",
    exam: "",
    subject: "",
    examDate: "",
    examTime: "",
    duration: "",
  });

  const [showYesNoModal, setShowYesNoModal] = useState(false);
  const [showTrueFalseModel, setShowTrueFalseModel] = useState(false);
  const [showRightWrongModel, setShowRightWrongModel] = useState(false);


  const [isEditable, setIsEditable] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setExamData(prev => ({ ...prev, [name]: value }));
  };

  // const openPopup = (type) => {

  //   const assessment_id = 1;   // Replace with dynamic value
  //   const quest_no = 1;        // Replace with dynamic value
  //   const std_div = examData.div;

  //   let url = "";

  //   switch (type) {
  //     case "TF":
  //       url = `/TrueFalse?Assessment_Id=${assessment_id}&Type_Desc=TF&Quest_No=${quest_no}`;
  //       break;

  //     case "YN":
  //       url = `/TrueFalse?Assessment_Id=${assessment_id}&Type_Desc=YN&Quest_No=${quest_no}`;
  //       break;

  //     case "RW":
  //       url = `/TrueFalse?Assessment_Id=${assessment_id}&Type_Desc=RW&Quest_No=${quest_no}`;
  //       break;

  //     case "MCQ":
  //       url = `/MCQ?Assessment_Id=${assessment_id}&Quest_No=${quest_no}`;
  //       break;

  //     case "MCQ_IMG":
  //       url = `/MCQImage?Assessment_Id=${assessment_id}&Std_Div=${std_div}&Quest_No=${quest_no}`;
  //       break;

  //     case "SHORT":
  //       url = `/ShortAnswer?Assessment_Id=${assessment_id}&Quest_No=${quest_no}`;
  //       break;

  //     default:
  //       break;
  //   }

  //   window.open(
  //     url,
  //     "Popup",
  //     "width=1000,height=500,left=100,top=100,resizable=yes"
  //   );
  // };

   const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      handleNew();
      setIsEditable(false);
    }
  };
   const handleNew = () => {
    setIsEditable(true);
     setExamData([{
       std: "",
       div: "",
       exam: "",
       subject: "",
       examDate: "",
       examTime: "",
       duration: "",
     }]);
  };

  return (
    <Container fluid className="p-3">

      {/* Header Card */}
      <Card className="p-4 mb-4 shadow-sm">
        <Row className="mb-3">
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Std</InputGroup.Text>
              <input
                className="form-control"
                name="std"
                value={examData.std}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Div</InputGroup.Text>
              <input
                className="form-control"
                name="div"
                value={examData.div}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Exam</InputGroup.Text>
              <input
                className="form-control"
                name="exam"
                value={examData.exam}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Subject</InputGroup.Text>
              <input
                className="form-control"
                name="subject"
                value={examData.subject}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Date</InputGroup.Text>
              <input
                type="date"
                className="form-control"
                name="examDate"
                value={examData.examDate}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Time</InputGroup.Text>
              <input
                type="time"
                className="form-control"
                name="examTime"
                value={examData.examTime}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Duration (min)</InputGroup.Text>
              <input
                className="form-control"
                name="duration"
                value={examData.duration}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
          </Row>

          <Row className="mb-3"></Row>

           <Row className="mb-3">

           <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Total Question</InputGroup.Text>
              <input
                className="form-control"
                name="duration"
                value={examData.duration}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>

           <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Total Marks</InputGroup.Text>
              <input
                className="form-control"
                name="duration"
                value={examData.duration}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
          </Row>

        <Row className="mb-3">
          <Col className="d-flex justify-content-end gap-2">
            <Button
              variant="primary"
              style={{ width: "135px" }}
            >
              Proceed
            </Button>

            <Button
              variant="secondary"
              style={{ width: "135px" }}
              onClick={handleClear}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Question Type Section */}
      <Card className="p-4 shadow-sm">

        <h5 className="text-center mb-4">
          Click on Question Types
        </h5>

        <Row className="justify-content-center g-4">

          <Col md={4} className="text-center">
            <Button className="question-btn" onClick={setShowTrueFalseModel}>True / False</Button>
            {showTrueFalseModel && (
              <TrueFalseModel show={showTrueFalseModel}handleClose={() => setShowTrueFalseModel(false)}
              />
            )}
          </Col>

          <Col md={4} className="text-center">
            <Button className="question-btn" onClick={() => setShowYesNoModal(true)}>Yes / No</Button>
            {showYesNoModal && (
              <YesNoModal show={showYesNoModal} handleClose={() => setShowYesNoModal(false)}
              />
            )}

          </Col>

          <Col md={4} className="text-center">
            <Button className="question-btn" onClick={() => setShowRightWrongModel(true)}>Right / Wrong</Button>
             {showRightWrongModel && (
              <RightWrongModel show={showRightWrongModel} handleClose={() => setShowRightWrongModel(false)}
              />
            )}
          </Col>

          <Col md={4} className="text-center">
            <Button
              className="question-btn"
            //  onClick={() => openPopup("MCQ")}
            >
              MCQ
            </Button>
          </Col>

          <Col md={4} className="text-center">
            <Button
              className="question-btn"
            //  onClick={() => openPopup("MCQ_IMG")}
            >
              MCQ - Image Based
            </Button>
          </Col>

          <Col md={4} className="text-center">
            <Button
              className="question-btn"
             // onClick={() => openPopup("SHORT")}
            >
              Short Answer
            </Button>
          </Col>

        </Row>
      </Card>

      {/* Custom Styling */}
      <style>
        {`
        .question-btn {
          width: 100%;
          height: 55px;
          background-color: lightblue;
          border: none;
          border-radius: 10px;
          font-weight: 500;
          transition: 0.3s;
        }

        .question-btn:hover {
          background-color: #008CBA;
          color: white;
        }
        `}
      </style>

    </Container>
  );
};

export default CreateExam;
